export default __webpack_public_path__ + "static/media/icon1.32cc0702.png";